export default function () {
    return {
        suppressHorizontalScroll: false,
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            cellDataType: false,
            suppressFieldDotNotation: false,
        },
        columnDefs: [{
            headerName: "Crew Member",
            children: [{
                headerName: "Name",
                field: "Name",
                pinned: "left",
                minWidth: 180,
            }, {
                headerName: "CCR",
                field: "CCR",
                pinned: "left",
                minWidth: 100,
            }, {
                headerName: "FTA",
                field: "FTA",
                minWidth: 100,
            }, {
                headerName: "Limitations",
                field: "Limitations",
                minWidth: 160,
            }, {
                headerName: "Status",
                field: "Status",
                minWidth: 110,
                cellStyle(params) {
                    return params.value === "Active"
                        ? { color: "#166534", fontWeight: 600 }
                        : { color: "#c2410f", fontWeight: 600 };
                }
            }]
        }, {
            headerName: "Role",
            headerTooltip: "Aeroplane / Helicopter for Pilot categories",
            children: [ {
                headerName: "Pilot Cat 2",
                headerTooltip: "Pilot Category 2 (Aeroplane / Helicopter)",
                field: "PilotCat2",
                type: "dualTick",
                minWidth: 90,
            }, {
                headerName: "Pilot Cat 4",
                headerTooltip: "Pilot Category 4 (Aeroplane / Helicopter)",
                field: "PilotCat4",
                type: "dualTick",
                minWidth: 90,
            }, {
                headerName: "LFTE",
                headerTooltip: "Lead Flight Test Engineer",
                field: "LFTE",
                type: "tick",
                minWidth: 70,
            }, {
                headerName: "FTE",
                headerTooltip: "Flight Test Engineer / Flight Engineer (Third crew member)",
                field: "FTE",
                type: "tick",
                minWidth: 70,
            }, {
                headerName: "Observer",
                headerTooltip: "Observer / Test Equipment Operator",
                field: "Observer",
                type: "tick",
                minWidth: 80,
            }]
        }, {
            headerName: "Test Flight Permissions",
            children: [{
                headerName: "CS-23",
                field: "CS-23",
                type: "permission",
                minWidth: 120,
            }, {
                headerName: "CS-23P",
                field: "CS-23P",
                type: "permission",
                minWidth: 120,
            }, {
                headerName: "CS-25",
                field: "CS-25",
                type: "permission",
                minWidth: 120,
            }]
        }]
    };
}
